import { render, staticRenderFns } from "./FollowersContainer.vue?vue&type=template&id=7d881ab6&"
import script from "./FollowersContainer.vue?vue&type=script&lang=tsx&"
export * from "./FollowersContainer.vue?vue&type=script&lang=tsx&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports